import React, { Component } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip} from 'reactstrap';
import { Link } from "react-router-dom";
import Route from "../../Routes";

import Logo   from "../../../assets/img/site/Logo.png";
import Avatar from "../../../assets/img/dashboard/users/avatar-1.png";
import http from "../../services/HttpService";
import i18next from 'i18next';
import { Translation } from "react-i18next";




const mapState = (state) => {
    return { };
};

@(connect(mapState) as any)
export default class Dashboard extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired
    };

    state = {
        openedCollapse: {

        },
        lng: i18next.language,
        languages:[],
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    // componentDidMount() {
    //     http.get('/site/languages')
    //         .then(response => response.json())
    //         .then((data) => {
    //             this.setState({
    //                 languages: data.languages,
    //             });
    //         });
    // }

    @autobind
    toggleMenuCollapse(event, key) {
        event.preventDefault();

        const { openedCollapse } = this.state;

        if (!openedCollapse.hasOwnProperty(key)) {
            openedCollapse[key] = false;
        }

        openedCollapse[key] = !openedCollapse[key];
        this.setState({
            openedCollapse,
        });
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const { openedCollapse, languages } = this.state;

        return (
            <div id="wrapper">
                <div className="topbar">

                    {/****************logo**************/}
                    <div className="topbar-left">
                        <Link to={Route.toUrl("dashboard_home")} className="logo">
                            <span>
                                <img src={Logo} alt=""/> <span className="my_style_dashboard_site_name">Skillers</span>
                            </span>
                        </Link>
                    </div>
                    {/****************logo END**************/}

                    {/***************navbar*****************/}
                    <nav className="navbar-custom">
                        <ul className="list-unstyled topbar-right-menu float-right my_dashboard_user_style">

                            <li className={`dropdown notification-list ${openedCollapse["components-0"] ? "show" : ""}`}>
                                <Link onClick={(e) => this.toggleMenuCollapse(event, "components-0")} className="nav-link dropdown-toggle waves-effect waves-light nav-user"
                                      data-toggle="dropdown" to="#" role="button"
                                      aria-haspopup="false" aria-expanded="false">
                                    <img src={Avatar} alt="user" className="rounded-circle my_user_icon_dashboard"/>
                                    <span className="ml-1">Admin<i className="mdi mdi-chevron-down"></i></span>
                                </Link>
                                <div className={`dropdown-menu dropdown-menu-right profile-dropdown ${openedCollapse["components-0"] ? "show" : ""}`} style={!openedCollapse["components-0"] ? { height: 0 } : {}}>

                                    <div>
                                        <Link to={Route.toUrl("dashboard_admin_settings")} className="dropdown-item notify-item">
                                            <i className="ti-settings"></i> <span>Settings</span>
                                        </Link>
                                    </div>

                                    <div>
                                        <Link to={Route.toUrl("account_logout")} className="dropdown-item notify-item">
                                            <i className="ti-power-off" /> <span>Logout</span>
                                        </Link>
                                    </div>

                                </div>
                            </li>
                        </ul>
                    </nav>

                </div>
                {/***************navbar END*****************/}

                {/*************** Left Sidebar Start*****************/}
                <div className="left side-menu">

                    <div id="sidebar-menu">

                        <ul className="metismenu" id="side-menu">


                            <li className={openedCollapse["components-2"] ? "active" : ""}>
                                <Link to="#" onClick={(e) => this.toggleMenuCollapse(event, "components-2")}>
                                    <i className="fa fa-home" />
                                    <span>Home</span>
                                    <span className="menu-arrow"  />
                                </Link>
                                <ul className={`nav-second-level collapse ${openedCollapse["components-2"] ? "in" : ""}`} style={!openedCollapse["components-2"] ? { height: 0 } : {}}>
                                    <li><Link to={Route.toUrl("dashboard_industry_all")}>All industries</Link></li>
                                    <li><Link to={Route.toUrl("dashboard_tool_all")}>All tools</Link></li>
                                </ul>
                            </li>

                            <li>
                                <Link to={Route.toUrl("dashboard_about_edit")}>
                                    <i className="fa fa-align-center" />
                                    <span>About</span>
                                </Link>
                            </li>

                            <li>
                                <Link to={Route.toUrl("dashboard_contact_edit")}>
                                    <i className="fa fa-volume-control-phone" />
                                    <span>Contact</span>
                                </Link>
                            </li>

                            <li>
                                <Link to={Route.toUrl("dashboard_user_all")}>
                                    <i className="fa fa-user" />
                                    <span>Users</span>
                                </Link>
                            </li>

                        </ul>

                    </div>

                    <div className="clearfix"></div>

                </div>
                {/*************** Left Sidebar END*****************/}

                {/*************** Start right Content here*****************/}
                <div className="content-page">

                    {/*************** Content*****************/}
                    <div className="content">

                        {this.props.children}

                        {/*************** Content END*****************/}

                        {/*************** Footer *****************/}
                        
                        {/*************** Footer END*****************/}

                    </div>

                </div>
                {/*************** End Right content here*****************/}

            </div>
        );
    }
}
